const { HomePageHandler } = require('../handlers/Hotel/HomePageHandler'),
    { SearchPageHandler } = require('../handlers/Hotel/SearchPageHandler'),
    { ProductDetailPageHandler } = require('../handlers/Hotel/ProductDetailPageHandler'),
    { PassengerDetailPageHandler } = require('../handlers/Hotel/PassengerDetailPageHandler'),
    { PassengerReviewPageHandler } = require('../handlers/Hotel/PassengerReviewPageHandler'),
    { PaymentPageHandler } = require('../handlers/Hotel/PaymentPageHandler'),
    { SessionExpireHandler } = require('../handlers/Hotel/SessionExpireHandler'),
    { ConfirmationPageHandler } = require('../handlers/Hotel/ConfirmationPageHandler');

const hotelMapping = {
    Home: HomePageHandler,
    Search: SearchPageHandler,
    ProductDetail: ProductDetailPageHandler,
    PassengerDetail: PassengerDetailPageHandler,
    PassengerReview: PassengerReviewPageHandler,
    Payment: PaymentPageHandler,
    SessionExpire: SessionExpireHandler,
    Confirmation: ConfirmationPageHandler
}

module.exports = { hotelMapping }